import request from '../../axios';

const PostSeedRequirement = async (payload: ISeedRequirementPayload) => {
  const newPayload = {
    title: payload.title,
    sub_input: payload.sub_input?.guid,
    location: `POINT (${payload.location?.lng} ${payload.location?.lat})`,
    wanted_weight: payload?.wanted_weight,
    weight_unit: payload.weight_unit?.value,
    only_massage_buyer: payload.only_massage_buyer || false,
    brs_type: payload.srs_type?.type,
    is_change_title: payload?.is_change_title,
    ad_type: payload.ad_type,
    images: payload?.images?.map(item => item),
    image: payload?.image,
  };
  const res = await request.post(`api/v2/wanted/seed-requirement`, {
    ...newPayload,
  });

  return res.data;
};

export default PostSeedRequirement;
